import { render } from "./AddShopTransaction.vue?vue&type=template&id=4d16b663"
import script from "./AddShopTransaction.vue?vue&type=script&lang=js"
export * from "./AddShopTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__